import { setConfig } from "~/services/ApiService"

export default ({ app }) => {
  setConfig({
    client: app.$axios,
    baseUrl: "/"
  })
}
